import React from "react";

const AboutInfo = () => {
  return (
    <div className="text-bg">
      <p className="about-intro">
        Hi, I'm Shoieb, a dedicated software engineer with a Bachelor of Science in Computer Science and Engineering,
        backed by almost four years of hands-on experience. My journey in the tech world revolves around a deep passion
        for developing innovative and scalable web applications.
        <br />
        <br />
        I specialize in building responsive and intuitive user interfaces using React and leveraging various CSS
        libraries to enhance the user experience. My commitment to delivering high-quality software solutions is evident
        in my work, where I seamlessly blend creativity with functionality.
        <br />
        <br />I am always on the lookout for new challenges and opportunities to expand my skills. I believe in making
        meaningful contributions to innovative projects that push boundaries and shape the future of technology.
      </p>
      <div className="about-rule" />
      <p className="about-signature">Building with curiosity, clarity, and care.</p>
    </div>
  );
};

export default AboutInfo;
